import { createFileRoute, redirect, Outlet } from "@tanstack/react-router";
import { getWorkspaceIdWithFallback } from "@/lib/routing/workspace-context";
import { getUserWorkspacesServer } from "@/server/user-workspaces";
import { logWarn } from "@/lib/structured-log";

export const Route = createFileRoute("/workspace/$workspaceSlug/settings/workspace/billing")({
  loader: async ({ context, params, parentMatchPromise }) => {
    const workspaceId = await getWorkspaceIdWithFallback(
      context,
      "billing-settings",
      parentMatchPromise,
    );
    const workspacesData = await getUserWorkspacesServer();
    const currentWorkspace = workspacesData.workspaces.find((ws) => ws.id === workspaceId);

    if (!currentWorkspace?.is_owner) {
      logWarn("billing.access_denied.not_owner", { workspaceId });
      throw redirect({
        to: "/workspace/$workspaceSlug/settings/workspace/general",
        params: { workspaceSlug: params.workspaceSlug },
      });
    }
    return { workspaceId };
  },
  component: Outlet,
});
